import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import drag from "v-drag";

Sentry.init({
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [new VueIntegration({ Vue, attachProps: true })]
});

Vue.config.productionTip = false;
Vue.use(drag, {});

new Vue({
  router,
  store,
  render: function (h) {
    return h(App);
  }
}).$mount("#app");
